export const N3Schema = {
    date: [
        { rule: "required", message: "Date required" },
    ],
    rent: [
        { rule: "required", message: "rent required" },
    ],
    newRent: [
        { rule: "required", message: "new rent required" },
    ],   
    amount: [
        { rule: "required", message: "amount required" },
    ],
    signingName: [
        { rule: "required", message: "signing name required" },
    ], 
    signingDate: [
        { rule: "required", message: "signing date required" },
    ], 
}